/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import "../../CSS/Pricing.css";
import { Button, Modal, OverlayTrigger, Tooltip, Card, Row, Col, Form, InputGroup } from "react-bootstrap";
import {
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@material-ui/core";
import Axios from "axios";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { trim } from "lodash";
import AuthenticationContext from "../../Store/Authentication-Context";
import Spinner from "react-bootstrap/Spinner";
import Slider from '@material-ui/core/Slider';
const PricingModel = (props) => {
    const urlParams = new URLSearchParams(window.location.search);
    const { setAuthContext } = useContext(AuthenticationContext);
    const [selectedPlan, setSelectedPlan] = useState("");
    const [displayOnly, setDisplayOnly] = useState(true);
    ////const [collapsed, setCollapsed] = useState(true);
    const [clickedPlan, setClickedPlan] = useState("");
    const [planDetails, setPlanDetails] = useState([]);
    const [showLoader, setShoeLoader] = useState(true);
    const [show, setShow] = useState(false);
    const qparams =new URLSearchParams(window.location.search);
    const [terms, setTerms] = useState([]);
    const [isBlurred, setIsBlurred] = useState(true);
    const [orgStatus, setOrgStatus] = useState(0);
    const [currentWeightage, setCurrentWeightage] = useState("");
    const [showDowngradeModal, setShowDowngradeModal] = useState(false);



    const [dataValue, setDataValue] = React.useState("");
    const [contractLength, setContractLength] = React.useState("1");

    //
    const [radioData, setRadioData] = React.useState([]);
    const [finalPrice, setFinalPrice] = useState(0);
    const [userCount, setUserCount] = useState(0);

    //

    const fetchStatusData = async () => {
        try {
            var tokenString = await setAuthContext("", new Date());

            const config = {
                headers: {
                    Authorisation: `Bearer ` + tokenString,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            const inputData = {
                OrgId: urlParams.get("orgId") ? urlParams.get("orgId") : null,
                Setting: "currentStatus",

            };

            const response = await Axios.get(API_ROUTE + Routes.GET_ORG_SETTINGS + '/' + urlParams.get("orgId"), config)
            if (response && response.data && response.data.currentStatus) {
                setOrgStatus(response.data.currentStatus)
            }
        } catch (error) {
            console.error("Error fetching status data:", error);
        }
    };

    const handleClose = () => {

        if (window.opener && window.opener.opener) {
            window.opener.opener.location.reload();
        }

        // Refresh the current window
        window.location.reload();
        setShow(false);
        setClickedPlan("");

    };
    const handleShow = () => setShow(true);
    const handlePlanSelection = (planName) => {
        setClickedPlan(planName);
        handleShow();
    };
    const handlePlanConfirm = async () => {
        let orgId = qparams.get("orgId") ? qparams.get("orgId") : "";
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        window.parent.location.reload();

        await Axios.put(API_ROUTE + Routes.PRICING_UPDATE(orgId, clickedPlan), null, config)
            .then((response) => {
                setSelectedPlan(clickedPlan);
                handleClose();
            }).catch((reason) => {
                ////let message = "";
                if (reason) {
                    if (reason.response) {
                        if (reason.response.data) {
                            ////message = reason.response.data;
                        }
                    }
                } else if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                handleClose();
            });
    };
    const [hoveredPlan, setHoveredPlan] = useState(null);
    const handleMouseEnter = (planName) => {
        setHoveredPlan(planName);
    };

    const handleMouseLeave = () => {
        setHoveredPlan(null);
    };

    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>

            {props.text}

        </Tooltip>

    );
    const renderFeatureName = (featureDescription, featureName, unitandValue,isLast) => {
        return <OverlayTrigger
            key="sort-1"
            placement={isLast ? "left" : "right" }
            delay={{ show: 250, hide: 400 }}
            overlay={(props) =>
                renderTooltip({
                    ...props,
                    id: "sort-1",
                    text: featureDescription,
                })
            }
        >
            <div style={{ fontSize: '18px' }} className="me-1">{featureName.trim()} <span style={{ fontSize: '18px', color: 'gray', fontWeight: '600' }}>{unitandValue.trim() !== "" && unitandValue}</span></div>
        </OverlayTrigger>
    }
    function valuetext(value) {
        return `${value} TB`;
    }

    const handleSliderChange = (event, newValue) => {
        setDataValue(newValue);
        calculatePrice(newValue, contractLength);
    };

    const calculatePrice = (newValue, contractLength, details) => {
        if (details) {
            const item = radioData.find(obj => obj.id === contractLength);
            //console.log(item)
            const pricingTier = details.priceBook.find(tier => newValue >= tier.sband && newValue <= tier.eband);
            const basePrice = pricingTier.price * newValue;
            let discountAmount = (item.value / 100) * basePrice;
            if (details.price.name.trim().toLowerCase() === 'payg') {
                discountAmount = 0;
            }
            const finalPrice = (basePrice - discountAmount).toFixed(2);
            setFinalPrice(finalPrice)
            if (newValue === 0) {
                setUserCount((0).toFixed(2));
            } else {
                setUserCount((finalPrice / newValue).toFixed(2));
            }
        }
        else if (selectedPlan && selectedPlan.price.name) {
            //console.log(newValue, contractLength)
            const item = radioData.find(obj => obj.id === contractLength);
            //console.log(item)
            const pricingTier = selectedPlan.priceBook.find(tier => newValue >= tier.sband && newValue <= tier.eband);
            const basePrice = pricingTier.price * newValue;
            let discountAmount = (item.value / 100) * basePrice;
            if (selectedPlan.price.name.trim().toLowerCase() === 'payg') {
                discountAmount = 0;
            }
            const finalPrice = (basePrice - discountAmount).toFixed(2);
            setFinalPrice(finalPrice)
            if (newValue === 0) {
                setUserCount((0).toFixed(2));
            } else {
                setUserCount((finalPrice / newValue).toFixed(2));
            }
        }
        
    };

    const termsData = async () => {
        //const tokenString = await setAuthContext("", new Date());
        let config = {
            headers: {
                Authorisation: "Bearer NOT REQUIRED`",
            },
        };
        const response = await Axios.get(API_ROUTE + Routes.GET_ALL_TERMS, config);
        if (response && response.data) {
            const responseData = JSON.parse(JSON.stringify(response.data));
            responseData.sort((a, b) => a.sortOrder - b.sortOrder);
            setTerms(responseData);
        }
    };
    const fetchData = async () => {
        try {
            let config = {
                headers: {
                    Authorisation: 'Bearer Token not need for Display only',
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = qparams.get("orgId") ? qparams.get("orgId") : "";
            let orgName = qparams.get("orgName") ? qparams.get("orgName") : "";
            let resellerOnlyParam = qparams.get("resellerOnly") ? qparams.get("resellerOnly") : "false";
            let displayOnlyParam = qparams.get("displayOnly") ? qparams.get("displayOnly") : "true";
            if (displayOnlyParam.toLowerCase() === "false") {
                var tokenString = await setAuthContext("", new Date());
                config = {
                    headers: {
                        Authorisation: `Bearer ` + tokenString,
                        CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                    },
                };
                setDisplayOnly(false);
            }
            else if (displayOnlyParam.toLowerCase() === "false") {

            }

            if (!orgId && orgId === "")
                console.log("Error fetching Organisation Details");


            const availablePlans = await Axios.get(API_ROUTE + Routes.PRICING_MODEL + "/" + orgId + "/" + orgName + "/" + resellerOnlyParam + "/" + displayOnly + "/true/0", config).then((response) => {
                var result = JSON.parse(response.data);
                setPlanDetails(result.filter((Detail) => Detail.features.length !== 0 && (!Detail.price.hideinPricelist)).sort((a, b) => b.features.length - a.features.length));
                
                return result;
            }).catch((reason) => {
                setShoeLoader(false);
                return "Error";
            });

            if (displayOnlyParam === "false") {
                await Axios.get(API_ROUTE + Routes.PRICING_MODEL_ID + "/" + orgId + "/" + orgName, config).then((response) => {
                    const selectedPlanDetailsJson = JSON.parse(response.data)
                    if (selectedPlanDetailsJson.price !== null) {
                        setSelectedPlan(selectedPlanDetailsJson.price.name)
                        setCurrentWeightage(selectedPlanDetailsJson.price.weightage)
                        if (availablePlans !== "Error") {
                            setPlanDetails(availablePlans.filter((Detail) => Detail.features.length !== 0 && (!Detail.price.hideinPricelist || selectedPlanDetailsJson.price.id === Detail.price.id) && Detail.price.weightage >= selectedPlanDetailsJson.price.weightage).sort((a, b) => b.features.length - a.features.length));
                        }
                    }
                    return selectedPlanDetailsJson;
                })
                    .catch((reason) => {
                        console.log(reason);
                        setShoeLoader(false);
                        if (reason?.response?.status === 440) {
                            window.location.href = "/TimeoutErrorHandler";
                        }
                    });
            }
            setShoeLoader(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDataTool = async () => {
        try {
            let config = {
                headers: {
                    Authorisation: "Bearer NOT REQUIRED`",
                },
            };
            ////let tabActiveKey = qparams.get("prod") ? qparams.get("prod") : "";
            ////if (tabActiveKey !== "") {
            ////    setActiveKey(tabActiveKey);
            ////    setDisplayTab(true);
            ////}
            let resellerId = qparams.get("reseller") ? qparams.get("reseller") : "0";
            let orgId = qparams.get("orgId") ? qparams.get("orgId") : "";
            ////let isBlur = qparams.get("isActive") ? qparams.get("isActive") : "";
            ////let orgName = qparams.get("orgName") ? qparams.get("orgName") : "";
            let resellerOnlyParam = qparams.get("resellerOnly")
                ? qparams.get("resellerOnly")
                : "false";
            let displayOnlyParam = qparams.get("displayOnly")
                ? qparams.get("displayOnly")
                : "true";
            ////let collapsedParam = qparams.get("collapsed")
            ////    ? qparams.get("collapsed")
            ////    : "false";
            ////let hideRRP = qparams.get("help") ? qparams.get("help") : "false";
            ////let filterid = qparams.get("id")
            ////    ? qparams.get("id").split(",").map(Number)
            ////    : [];
            let internal = qparams.get("internal")
                ? qparams.get("internal")
                : "false";
            ////if (hideRRP === "true") {
            ////    setHideRRP(false);
            ////}
            if (internal === "true") {
                setIsBlurred(false);
            }
            if (displayOnlyParam.toLowerCase() === "false") {
                config = {
                    headers: {
                        Authorisation: `Bearer `,
                    },
                };
                setDisplayOnly(false);
            }
            else if (displayOnlyParam.toLowerCase() === "false") {
                //orgId = resellerId;
                //setDisplayOnly(false)
            }
            ////if (collapsedParam === "true") {
            ////    setCollapsed(true);
            ////} else if (collapsedParam === "false") {
            ////    setCollapsed(false);
            ////}
            if (!orgId && orgId === "")
                console.log("Error fetching Organisation Details");

             await Axios.get(API_ROUTE +
                "TenantService/TenantServices" +
                "/" +
                "default" +
                "/" +
                "pricingTool" +
                "/" +
                resellerOnlyParam +
                "/true" +
                ////displayOnly +
                "/true/" + resellerId,
                config
            )
                .then((response) => {
                    var result = JSON.parse(response.data);
                    setPlanDetails(result.filter((Detail) => Detail.features.length !== 0 && (!Detail.price.hideinPricelist)).sort((a, b) => b.features.length - a.features.length));
                    //console.log(result.filter((Detail) => Detail.features.length !== 0 && (!Detail.price.hideinPricelist)).sort((a, b) => b.features.length - a.features.length))
                    // setPlanDetails(
                    //   result
                    //     .filter(
                    //       (Detail) =>
                    //         Detail.features.length !== 0 &&
                    //         !filterid.includes(Detail.price.id)
                    //     )
                    //     .sort((a, b) => b.features.length - a.features.length)
                    // );
                })
                .catch((reason) => {
                    console.log(reason);
                    setShoeLoader(false);
                });

             await Axios.get(API_ROUTE +
                "TenantService/GetDiscounts/default", config)
                .then((response) => {

                    const formatted = response.data.map(item => ({
                        id: String(item.id),
                        value: item.discountPercent,
                        label: item.term
                    }));
                    setRadioData(formatted)
                })
                .catch((reason) => {
                    console.log(reason);
                });

            ////if (displayOnlyParam === "false") {
            ////    const selectedplandetails = await Axios.get(
            ////        "https://365Api-preview.virtualdcs.co.uk:443/api/" +
            ////        // "http://localhost:5000/api/" +
            ////        "TenantService/TenantServiceById" +
            ////        "/" +
            ////        "AAA" +
            ////        "/" +
            ////        "BBB",
            ////        config
            ////    )
            ////        .then((response) => {
            ////            const selectedPlanDetailsJson = JSON.parse(response.data);
            ////            if (selectedPlanDetailsJson.price !== null) {
            ////                setSelectedPlan(selectedPlanDetailsJson.price.name);
            ////                setResellerId(selectedPlanDetailsJson.price.resellerId);
            ////            }
            ////        })
            ////        .catch((reason) => {
            ////            console.log(reason);
            ////            setShoeLoader(false);
            ////        });
            ////}
            setShoeLoader(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {
        termsData();
        if (props.page === 'PricingModel') {
            
            fetchData();
        }
        else {
            fetchDataTool();
            const handleMessage = (event) => {
                // Check that the message is coming from the expected parent domain
                ////if (event.origin !== 'https://pricingtool.virtualdcs.co.uk/') {
                ////    console.warn('Message received from unauthorized origin');
                ////    return;
                ////}
                if (event.data === false) {

                    setIsBlurred(false);
                }
                else if (event.data === true) {
                    setIsBlurred(true);
                }
                
            };

            window.addEventListener('message', handleMessage);

            // Cleanup on component unmount
            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
        fetchStatusData();
    }, []);
    //
    
    const marks = [
        {
            value: 0,
            label: "0",
        },
        {
            value: 500,
            label: "500",
        },
    ];

    const handleInputChange = (event) => {
        var targetValue =
            event.target.value === "" ? 0 : Number(event.target.value);

        if (targetValue > 500) {
            targetValue = 500;
            setDataValue(500);
        } else {
            setDataValue(targetValue);
        }
        calculatePrice(targetValue, contractLength);
    };

    const contractLengthChange = (event) => {
        var targetValue = event.target.value;
        setContractLength(targetValue);
        calculatePrice(dataValue, targetValue);
        
    };

    const handlePriceModalSelection = async (details) => {
        if (props.page === 'PricingTool') {
            try {
                setSelectedPlan(details)
                if (dataValue !== 0 && contractLength !== "") {
                    calculatePrice(dataValue, contractLength, details);
                }
            } catch (error) {
                toast.error("Error deleting user:", error);
            }
        }
    };

    const handleShowParent = () => {
        const message = true
        window.parent.postMessage(message, '*');
    };
    const handleShowRequestCall = () => {
        const message = "RequestCall"
        window.parent.postMessage(message, '*');
    };
    const planNotSelected = () => {
        //showToast("warning", "Please select a package");
        const message = "planNotSelected"
        if (!isBlurred) {
            window.parent.postMessage(message, '*');
        }
        
    };
    useEffect(() => {
        var message = {
            selectedPlan: selectedPlan?.price?.name ?? '',
            users: dataValue,
            length: contractLength
        }
        window.parent.postMessage(JSON.stringify(message), '*');
    }, [selectedPlan, dataValue, contractLength]);
    const stylePricingTool = {
        minWidth: "fit-content",
        ...(props.page === "PricingTool" ? {
            maxHeight: '51rem',
            overflow: 'auto',
            overflowX: 'hidden'
        } : {})
    };
    //
    return (

        <>

            <div className="container p-0">
                <div className={`centered-div ${props.page}`} id="pricing">
                    {showLoader ? (
                        <div
                            className="justify-content-center align-items-center d-flex h-100"
                            style={{ minHeight: "35vh" }}
                        >
                            <Spinner
                                animation="border"
                                style={{ color: "#669ed4" }}
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : planDetails.length !== 0 ? (
                        <>
                            <div
                                    className={props.page === 'PricingModel'?"p-3":""}
                                    style={stylePricingTool}
                                >
                                    {props.page === "PricingTool" && <div style={{ display: 'flex', justifyContent: 'center', background: '#34af49', color: 'white', margin: '19px', padding: '9px', borderRadius: '10px', fontSize:'24px' }}>
                                        <div><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-info-circle-fill me-2" viewBox="0 0 16 16">
                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                                        </svg>
                                            <b>More than 25 users?</b> You can access additional discounts. Just select your desired package and then input your user number below.</div>
                                    </div>}
                                    <div className="row gx-3 gy-4 justify-content-center">
                                    {planDetails.map(
                                        (Detail, detailIndex) =>
                                            Detail.features.length !== 0 && (
                                                <div
                                                    key={Detail.price.id}
                                                    className="col-12 col-sm-6 col-md-4 col-lg d-flex"
                                                    
                                                >
                                                    <div
                                                        id={"price-model-" + Detail.price.id}
                                                        onClick={() => handlePriceModalSelection(Detail)}
                                                        style={{
                                                            border: "2px solid",
                                                            borderRadius: "30px",
                                                            minWidth: "0", // prevent overflow
                                                        }}
                                                        className={`price-model-card card flex-fill m-1 ${selectedPlan === Detail.price.name && "selected-div"}`}
                                                    >
                                                        <div className="card-header pricing-card-header" style={{ textAlign: 'center', border: '3px solid', borderTopLeftRadius: '30px', borderTopRightRadius: '30px', fontSize: '30px', fontWeight: 'bold' }}>
                                                            {Detail.price.name}
                                                        </div>

                                                        <div className="pricing-body" style={{ textAlign: 'left', padding: '5% 5% 5% 5%', cursor: 'default', height: '100%' }}>
                                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <div className="price-title" style={{ fontSize: '2.5rem', textAlign: 'center', fontWeight: '600', borderBottom: '5px solid #4993dc', padding: '0 10px 0 10px' }}>

                                                                    {Detail.priceBook
                                                                        .sort((a, b) => a.id - b.id)[0].currency.trim() === "GBP"
                                                                        ? <svg className="mb-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" fill="currentColor">
                                                                            <path
                                                                                d="M4 8.585h1.969c.115.465.186.939.186 1.43 0 1.385-.736 2.496-2.075 2.771V14H12v-1.24H6.492v-.129c.825-.525 1.135-1.446 1.135-2.694 0-.465-.07-.913-.168-1.352h3.29v-.972H7.22c-.186-.723-.372-1.455-.372-2.247 0-1.274 1.047-2.066 2.58-2.066a5.3 5.3 0 0 1 2.103.465V2.456A5.6 5.6 0 0 0 9.348 2C6.865 2 5.322 3.291 5.322 5.366c0 .775.195 1.515.399 2.247H4z"
                                                                                style={{ strokeWidth: '0.5' }}
                                                                            />
                                                                        </svg>
                                                                        : Detail.priceBook
                                                                            .sort((a, b) => a.id - b.id)[0].currency.trim() === "EUR"
                                                                            ? <svg
                                                                                className="mb-2"
                                                                                fill="currentColor"
                                                                                height="1em"
                                                                                width="1em"
                                                                                viewBox="0 0 16 16"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936q-.002-.165.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.6 6.6 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="0.5"
                                                                                />
                                                                            </svg>
                                                                            : "test"}
                                                                    {Detail && Detail.priceBook && Detail.priceBook
                                                                        .sort((a, b) => a.id - b.id)[0].price.toFixed(2)} <span>PUPM</span>
                                                                </div>
                                                            </div>
                                                            <div className="mt-3 mb-3" style={{ textAlign: 'center', fontSize: '14px', fontWeight: '500' }}>{Detail.price.description}</div>
                                                            {Detail.features.filter(
                                                                (FeatureDetail) => !FeatureDetail.smallPrint
                                                            )
                                                                .sort((a, b) => a.sortOrder - b.sortOrder)
                                                                .map((feature, index) => (
                                                                    <>
                                                                        <div className="mb-2" style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <>
                                                                                {feature.featureValue.toLowerCase() ===
                                                                                    "true" ? <div> <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="32"
                                                                                        height="20"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-check text-success"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
                                                                                    </svg>
                                                                                </div> : feature.featureValue.toLowerCase() ===
                                                                                    "false" ? <div><svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="32"
                                                                                        height="20"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-x text-danger"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                                                                                    </svg></div> : trim(feature.featureValue) === "" ?
                                                                                    <div> <svg id="oneeeee"
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="32"
                                                                                        height="20"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-x text-danger"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                                                                                    </svg></div> : isNaN(
                                                                                        parseInt(feature.featureValue)
                                                                                    ) ? <><div><svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="32"
                                                                                        height="20"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-check text-success"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
                                                                                    </svg></div></> : <><div><svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="32"
                                                                                        height="20"
                                                                                        fill="currentColor"
                                                                                        className="bi bi-check text-success"
                                                                                        viewBox="0 0 16 16"
                                                                                    >
                                                                                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
                                                                                    </svg></div></>
                                                                                }

                                                                                {feature.featureValue.toLowerCase() ===
                                                                                    "true" ? <>{renderFeatureName(feature.featureDescription, feature.featureName, '', planDetails.length - 1 === detailIndex)}</> : feature.featureValue.toLowerCase() ===
                                                                                        "false" ? <>{renderFeatureName(feature.featureDescription, feature.featureName, '', planDetails.length - 1 === detailIndex)}</> : trim(feature.featureValue) === "" ?
                                                                                            <>{renderFeatureName(feature.featureDescription, feature.featureName, '', planDetails.length - 1 === detailIndex)}</> : isNaN(
                                                                                        parseInt(feature.featureValue)
                                                                                            ) ? <>{renderFeatureName(feature.featureDescription, feature.featureName, '', planDetails.length-1 === detailIndex)}</>
                                                                                        //   <span className="me-2" style={{ border:'1px solid',padding:'3px',borderRadius:'6px',background:'#4993dc',color:'white',fontWeight:'bold' }}>
                                                                                        //   {feature.featureName}
                                                                                        // </span> 
                                                                                        :
                                                                                        // <span className="me-2" style={{width:'92px',textAlign:'center', border:'1px solid',padding:'3px',borderRadius:'6px',background:'#4993dc',color:'white',fontWeight:'bold' }}>
                                                                                        //       {feature.featureValue}{" "}
                                                                                        //       {feature.featureUnit}
                                                                                        //     </span>
                                                                                                <>{renderFeatureName(feature.featureDescription, feature.featureName, " : " + feature.featureValue + " " + feature.featureUnit, planDetails.length-1 === detailIndex)}</>

                                                                                }
                                                                            </>
                                                                        </div>
                                                                    </>
                                                                ))}
                                                        </div>

                                                        {props.page === 'PricingTool' && selectedPlan && selectedPlan.price.name === Detail.price.name ? (
                                                            <div className="card-footer">Selected Plan</div>
                                                        ) : (
                                                                props.page !== 'PricingModel' && <div style={{ height: '4.3rem' }}></div>
                                                        )}
                                                        {!displayOnly && props.page !=='PricingTool' &&
                                                            <div
                                                                onMouseEnter={() => handleMouseEnter(Detail.price.name)}
                                                                onMouseLeave={handleMouseLeave}
                                                                className={`plans plan-checkbox ${selectedPlan === Detail.price.name && !displayOnly ? "selectedplan" : ""
                                                                    } ${hoveredPlan === Detail.price.name && !displayOnly ? "hover-effect" : ""
                                                                    } ${clickedPlan === Detail.price.name && !displayOnly ? "hover-effect" : ""
                                                                    }`}
                                                                style={{ borderTopLeftRadius: '0', borderTopRightRadius: '0', borderTopWidth: '1px' }}
                                                            >
                                                                {!Detail.price.nonSelectable ?
                                                                    (<div className="justify-content-center d-flex p-2">
                                                                        <input
                                                                            type="checkbox"
                                                                            onClick={() => {
                                                                                //if (selectedPlan !== Detail.price.name) {
                                                                                //    handlePlanSelection(Detail.price.name, Detail.price.id);
                                                                                //}
                                                                                if (orgStatus !== "TRIAL") {
                                                                                    if (Detail.price.weightage >= currentWeightage) {
                                                                                        handlePlanSelection(Detail.price.name, Detail.price.id);
                                                                                    }
                                                                                    else {
                                                                                        setShowDowngradeModal(true);
                                                                                    }
                                                                                }
                                                                                else {
                                                                                    handlePlanSelection(Detail.price.name, Detail.price.id);
                                                                                }
                                                                            }}
                                                                            htmlFor={`checkbox_${Detail.price.id}`}
                                                                            id={`checkbox_${Detail.price.id}`}
                                                                            checked={selectedPlan === Detail.price.name}
                                                                            className="form-check-input"
                                                                            value="1"
                                                                            readOnly
                                                                        />
                                                                        <label className="form-check-label"></label>
                                                                    </div>) : (selectedPlan === Detail.price.name) && (<div className="justify-content-center align-items-center d-flex p-2" style={{ borderBottom: "1px solid #dee2e6", height: '48px' }}>
                                                                        <OverlayTrigger key="sort-1" placement="right" delay={{ show: 250, hide: 400 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Contact Support" })}>
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="35"
                                                                                height="35"
                                                                                fill="currentColor"
                                                                                className="bi bi-check text-success"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"></path>
                                                                            </svg>
                                                                        </OverlayTrigger>

                                                                        <label className="form-check-label"></label>
                                                                    </div>)}
                                                            </div>
                                                        }


                                                    </div>
                                                </div>
                                            )
                                    )}
                                </div>
                                </div>
                                {props.page === "PricingTool" && 
                                    <div className="card" id="get-quote" style={{ border: '2px solid #4993dc', borderRadius: '10px', margin: '15px' }}>
                                        <div className="card-header" style={{ textAlign: 'center', fontSize: '2rem', fontWeight: 'bold', borderRadius: '10px' }}>
                                            Get your quote
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-8 pt-2">
                                                    <Card style={{ borderColor: "white" }}>
                                                        {selectedPlan && selectedPlan.price.name ?
                                                            
                                                            <Card.Body>
                                                                <Row>
                                                                    <Col sm={12} className="justify-content-start d-flex">
                                                                        <span className="font-weight-bold t-primary me-2 labels" style={{ fontSize: '1.25rem' }}>
                                                                            Number of Users
                                                                        </span>
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <Slider
                                                                            min={0}
                                                                            max={500}
                                                                            step={1}
                                                                            getAriaValueText={valuetext}
                                                                            value={typeof dataValue === "number" ? dataValue : 0}
                                                                            onChange={handleSliderChange}
                                                                            aria-labelledby="input-slider"
                                                                            valueLabelDisplay="auto"
                                                                            marks={marks}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                        <InputGroup className="mb-3">
                                                                            <Form.Control
                                                                                type="number"
                                                                                value={dataValue}
                                                                                onChange={handleInputChange}
                                                                                placeholder="0"
                                                                                aria-label="Server(s)"
                                                                                min="0"
                                                                                max="500"
                                                                                step="1"
                                                                                aria-describedby="basic-addon1"
                                                                            />
                                                                            <InputGroup.Text id="basic-addon1">User(s)</InputGroup.Text>
                                                                        </InputGroup>
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="contract-length-label"
                                                                            name="contractLength"
                                                                            value={contractLength}
                                                                            onChange={contractLengthChange}
                                                                            className="radioGroupRoot"
                                                                        >
                                                                            {radioData.map((item) => (
                                                                                <FormControlLabel
                                                                                    key={item.id}
                                                                                    value={item.id}
                                                                                    control={<Radio className="radioHidden" />}
                                                                                    label={
                                                                                        <span
                                                                                            className={`labelBox ${contractLength === item.id ? "labelBoxSelected" : ""
                                                                                                }`}
                                                                                        >
                                                                                            {item.label}
                                                                                        </span>
                                                                                    }
                                                                                    className="formControlLabel"
                                                                                />
                                                                            ))}
                                                                        </RadioGroup>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                            :
                                                            <Card.Body className={` blur`} style={{ PointerEvent: 'none' }} onClick={planNotSelected }>
                                                                <Row>
                                                                    <Col sm={12} className="justify-content-start d-flex">
                                                                        <span className="font-weight-bold t-primary me-2 labels" style={{ fontSize: '1.25rem' }}>
                                                                            Number of Users
                                                                        </span>
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <Slider
                                                                            min={0}
                                                                            max={500}
                                                                            step={1}
                                                                            getAriaValueText={valuetext}
                                                                            value={typeof dataValue === "number" ? dataValue : 0}
                                                                            aria-labelledby="input-slider"
                                                                            valueLabelDisplay="auto"
                                                                            marks={marks}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                        <InputGroup className="mb-3">
                                                                            <Form.Control
                                                                                type="number"
                                                                                value={dataValue}
                                                                                placeholder="0"
                                                                                aria-label="Server(s)"
                                                                                min="0"
                                                                                max="500"
                                                                                step="1"
                                                                                aria-describedby="basic-addon1"
                                                                            />
                                                                            <InputGroup.Text id="basic-addon1">User(s)</InputGroup.Text>
                                                                        </InputGroup>
                                                                    </Col>
                                                                    <Col sm={10}>
                                                                        <RadioGroup
                                                                            row
                                                                            aria-labelledby="contract-length-label"
                                                                            name="contractLength"
                                                                            value={contractLength}
                                                                            className="radioGroupRoot"
                                                                        >
                                                                            {radioData.map((item) => (
                                                                                <FormControlLabel
                                                                                    key={item.id}
                                                                                    value={item.id}
                                                                                    control={<Radio className="radioHidden" />}
                                                                                    label={
                                                                                        <span
                                                                                            className={`labelBox ${contractLength === item.id ? "labelBoxSelected" : ""
                                                                                                }`}
                                                                                        >
                                                                                            {item.label}
                                                                                        </span>
                                                                                    }
                                                                                    className="formControlLabel"
                                                                                />
                                                                            ))}
                                                                        </RadioGroup>
                                                                    </Col>
                                                                </Row>
                                                            </Card.Body>
                                                        }
                                                        
                                                    </Card>
                                                </div>
                                                <div className="modern-card col-sm-4">
                                                    {isBlurred ? 
                                                        <>
                                                            <div
                                                                onClick={handleShowParent}
                                                                className="heartbeat p-2 ps-4 pe-4 four"
                                                                style={{ right:'13.5%' }}
                                                            >
                                                                <span>Show Pricing</span>
                                                            </div>
                                                            <div className={`blurred-card blur bllurred-four p-2`}>
                                                                <Card className="shadow-sm rounded-lg">
                                                                    <Card.Body>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Rate
                                                                        </Card.Title>
                                                                        <Card.Text className="font-weight-medium">
                                                                            £&nbsp;0/ User
                                                                        </Card.Text>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Price
                                                                        </Card.Title>
                                                                        <Card.Text className="font-weight-medium">
                                                                            £&nbsp;0/ mo
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                        </>

                                                        :
                                                        contractLength === "1" && dataValue < 150 ? (
                                                            <div className={`blurred-card p-2`}>
                                                                <Card className="shadow-sm rounded-lg">
                                                                    <Card.Body>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Rate
                                                                        </Card.Title>
                                                                        <Card.Text className="font-weight-medium">
                                                                            £&nbsp;{userCount}/ User
                                                                        </Card.Text>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Price
                                                                        </Card.Title>
                                                                        <Card.Text className="font-weight-medium">
                                                                            £&nbsp;{finalPrice}/ mo
                                                                        </Card.Text>
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                        )
                                                            :
                                                            <div className={`blurred-card p-2`}>
                                                                <Card className="shadow-sm rounded-lg">
                                                                    <Card.Body>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Rate
                                                                        </Card.Title>
                                                                        <button className="btn btn-primary" onClick={handleShowRequestCall}>Request Call</button>
                                                                        <Card.Title className="font-weight-bold textprimary">
                                                                            Price
                                                                        </Card.Title>
                                                                        <button className="btn btn-primary" onClick={handleShowRequestCall}>Request Call</button>
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>}
                                                    
                                                </div>

                                            </div>
                                        </div>
                                    </div>}
                                {props.page !== 'PricingTool' && terms.length !== 0 && (
                                    <div
                                        className="m-3 p-3"
                                        style={{ borderRadius: "8px", border: "1px solid #5091ce", textAlign: 'left' }}
                                    >
                                        <ol className="ps-3 m-0">
                                            {terms.map((term, index) => (
                                                <li key={index} className=" mb-2">
                                                    {term.termDescription}
                                                </li>
                                            ))}
                                        </ol>
                                    </div>
                                )}
                        </>
                    ) : (
                        <div
                            className="justify-content-center align-items-center d-flex"
                            style={{ height: "100vh" }}
                        >
                            <h3>No Active Price Model to display</h3>
                        </div>
                    )}
                </div>
                <ToastContainer limit={4} style={{ fontSize: "small" }} />
                <Modal
                    show={show}
                    onHide={handleClose}
                    centered
                    backdrop="static"
                    keyboard={false}
                >

                    <Modal.Body>
                        Are you sure you wish to use the <b> {clickedPlan} </b>price model,
                        your bill will reflect the selected model.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary " onClick={handlePlanConfirm}>
                            Yes
                        </Button>
                        <Button variant="danger" onClick={handleClose}>
                            No
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDowngradeModal} onHide={() => setShowDowngradeModal(false)}
                    centered
                    backdrop="static"
                    keyboard={false}>
                    <Modal.Body>
                        You cannot downgrade your package you have committed to your current package until your contract renew date.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => setShowDowngradeModal(false)}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>


        </>

    )
}

export default PricingModel